/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import styled from "styled-components";

export const BockQuote = styled.div`
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  border-left: 3px solid ${(props) => props?.secondaryColor};
  padding: 10px;
  border-radius: 5px;
`;

export const Description = styled.p`
  font-size: 14px;
  text-align: justify;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
`;
